import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { environment } from '../../../../environments/environment';
import { IPost} from '../models/ipost';

import 'rxjs/add/operator/find';
import 'rxjs/add/observable/of';

@Injectable()
export class PostsService {
  private _apiEndPoint = environment.madeByGdmAPIV1.url + environment.madeByGdmAPIV1.endPoints.posts;

  constructor(private _httpClient: HttpClient) {
  }

  getPosts(amount: number): Observable<Array<IPost>> {
    return this._httpClient.get<Array<IPost>>(`${ this._apiEndPoint }`);
  }

}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/posts/shared/services/posts.service.ts